import React from "react";
import numbro from "numbro";
import PoMobileItem from "./poMobileItem";

const PoItemMobile = ({ contents }) => {
    return (
        <div className="d-md-none">
            <h6 className="fw-bold mb-2 mx-3">SKUs</h6>
            <hr
                style={{
                    height: "2px",
                    backgroundColor: "#0F8613",
                    border: "none",
                    opacity: 1,
                    width: "100%",
                    padding: "0px",
                    margin: "0px",
                }}
            />

            {contents.map((item, index) => (
                <PoMobileItem key={index} item={item} index={index} />
            ))
            }
            <div className="d-flex justify-content-center">
                <hr
                    className="mt-5 mx-4"
                    style={{
                        height: '2px',
                        width: '148px',
                        backgroundColor: '#9AA5B1',
                        border: 'none',
                        marginBottom: '100px'
                    }}
                />
            </div>

            {/* Fixed Bottom Total Payable */}
            <div
                className="d-md-none position-fixed bottom-0 start-0 end-0 bg-white px-3 py-3"
                style={{
                    zIndex: 1050,
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                    boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
                    height: "54px",
                    overflow: "hidden",
                }}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <span
                        style={{
                            fontSize: "16px",
                            fontWeight: 400,
                            color: "#616E7C",
                            fontFamily: "Inter, sans-serif",
                        }}
                    >
                        Total payable
                    </span>
                    <span
                        style={{
                            fontSize: "16px",
                            fontWeight: 700,
                            color: "#000",
                            fontFamily: "Inter, sans-serif",
                        }}
                    >
                        PKR{" "}
                        {(() => {
                            const total = contents.reduce(
                                (sum, item) => sum + (item.payable_paisas || 0),
                                0
                            );
                            return numbro(total / 100).format({
                                thousandSeparated: true,
                                mantissa: 2,
                            });
                        })()}
                    </span>
                </div>
            </div>

        </div >
    );
};

export default PoItemMobile;
